export const baseUrl = 'https://api.github.com/search/issues?q=';
export const resultPerPage = 20;
export const sortOptions = `+state:open&sort=created&order=desc&per_page=${resultPerPage}`;
export const gAnalyticsID = 'G-S4SCPLGLKY';
